export let accCheckerMenuItemText = "ffHEOb";
export default {accCheckerMenuItemText};